import { SearchSortEnum } from '@iheartjane/dm-sdk';

import type { CurrentSort } from '@jane/search/data-access';

export const mapCurrentSortToSearchSort = (
  currentSort: CurrentSort | undefined
): SearchSortEnum => {
  const suffix = currentSort?.suffix || '';
  switch (suffix) {
    case 'by-category-and-name-':
      return SearchSortEnum.CategoryAndNameAsc;
    case 'by-price-':
      return SearchSortEnum.PriceAsc;
    case 'by-price-desc-':
      return SearchSortEnum.PriceDesc;
    case 'by-price-eighth-ounce-':
      return SearchSortEnum.PriceEighthOunceAsc;
    case 'by-price-eighth-ounce-desc-':
      return SearchSortEnum.PriceEighthOunceDesc;
    case 'by-price-gram-':
      return SearchSortEnum.PriceGramAsc;
    case 'by-price-gram-desc-':
      return SearchSortEnum.PriceGramDesc;
    case 'by-price-half-gram-':
      return SearchSortEnum.PriceHalfGramAsc;
    case 'by-price-half-gram-desc-':
      return SearchSortEnum.PriceHalfGramDesc;
    case 'by-price-half-ounce-':
      return SearchSortEnum.PriceHalfOunceAsc;
    case 'by-price-half-ounce-desc-':
      return SearchSortEnum.PriceHalfOunceDesc;
    case 'by-price-ounce-':
      return SearchSortEnum.PriceOunceAsc;
    case 'by-price-ounce-desc-':
      return SearchSortEnum.PriceOunceDesc;
    case 'by-price-quarter-ounce-':
      return SearchSortEnum.PriceQuarterOunceAsc;
    case 'by-price-quarter-ounce-desc-':
      return SearchSortEnum.PriceQuarterOunceDesc;
    case 'by-price-two-gram-':
      return SearchSortEnum.PriceTwoGramAsc;
    case 'by-price-two-gram-desc-':
      return SearchSortEnum.PriceTwoGramDesc;
    case 'by-rating-':
      return SearchSortEnum.Rating;
    case 'by-recommendation-ordinal-asc-':
      return SearchSortEnum.Recommendation;
    case 'by-thc-potency-asc-':
      return SearchSortEnum.ThcPotencyAsc;
    case 'by-thc-potency-desc-':
      return SearchSortEnum.ThcPotencyDesc;
    case 'best-seller-rank':
      return SearchSortEnum.BestSellerRank;
    default:
      return SearchSortEnum.Default;
  }
};
